import * as React from "react";
import {Option} from "ts-option";
import DataGrid from "../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import SectionView from "../../layout/section/SectionView";
import AssetHistory from "../../../model/asset/AssetHistory";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import DateUtils from "../../../utils/DateUtils";
import {TierLevel} from "../../../model/asset/Asset";
import CurrencyHelper from "../../../helper/CurrencyHelper";
import "./assetHistryTable.scss"

interface ComponentProps {
	/**
	 * Asset history list
	 */
	assetHistory: Option<AssetHistory[]>;
	/**
	 * Assets categories list.
	 */
	assetsCategories: DictionaryItem[];
}

export default class AssetHistoryTable extends React.Component<ComponentProps> {

	render() {
		return (
			<SectionView customClass={"asset-history-table"}>
				<DataGrid>
					<thead>
					<tr>
						<th>Timestamp</th>
						<th>Manufacturer</th>
						<th>Model</th>
						<th>Category</th>
						<th>Type</th>
						<th className={"t-right"}>Price</th>
						<th className={"t-center"}>Secondary price</th>
						<th>Markup</th>
						<th className={"t-right"}>Rebate</th>
						<th className={"t-center"}>Merchant code 1</th>
						<th className={"t-center"}>Merchant code 2</th>
						<th>Description</th>
						<th>Tier</th>
						<th>Points</th>
						<th>Keywords</th>
						<th className={"t-center"}>Alert note</th>
						<th className={"t-center"}>Warranty code</th>
					</tr>
					</thead>
					<tbody>
					{this.props.assetHistory.getOrElse([]).map((item, index) => {
						const category = this.props.assetsCategories.filter(aCat => aCat.id === item.categoryId)[0];
						return (
							<tr key={index}>
								<td>{item.dateTime.format(DateUtils.DATE_TIME_FORMAT)}</td>
								<td>{item.manufacturer.getOrElse("")}</td>
								<td>{item.model}</td>
								<td>{category ? category.name : ''}</td>
								<td>{item.type.getOrElse("")}</td>
								<td className={"t-right"}>{item.formatPrice()}</td>
								<td className={"t-right"}>{item.formatSecondaryPrice()}</td>
								<td>{`${item.markup}%`}</td>
								<td className={"t-right"}>{item.rebate.map(CurrencyHelper.penniesToPounds).orNull}</td>
								<td>{item.firstMerchantCode.getOrElse('')}</td>
								<td>{item.secondMerchantCode.getOrElse('')}</td>
								<td>{item.description.getOrElse('')}</td>
								<td>{TierLevel[item.tierLevel].capitalize()}</td>
								<td>{item.rewardsPoints}</td>
								<td>{item.keywords.join(', ')}</td>
								<td>{item.alertNote.getOrElse('')}</td>
								<td>{item.warrantyCode.getOrElse('')}</td>
							</tr>
						)
					})}
					</tbody>
				</DataGrid>
			</SectionView>
		)
	}
}
